import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'bootstrap';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import accouting from 'accounting';

import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

import firebase from 'firebase'; 
import { firebaseConfig } from './configuracion/firebaseConfig';

import VueGeoLocation from 'vue-browser-geolocation';


 // Initialize Firebase
 firebase.initializeApp(firebaseConfig);
 export const db = firebase.firestore();
// Get a reference to the storage service, which is used to create references in your storage bucket
 export const storage = firebase.storage();   // https://firebase.google.com/docs/storage/web/create-reference?hl=es


// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.filter('formato',(monto)=>{
  return accouting.formatMoney(monto,'$',0,'.',',');
})
Vue.filter('formato2',(monto)=>{
  return accouting.formatMoney(monto,'',0,'.',',');
})
Vue.filter('formato3',(monto)=>{
  return accouting.formatMoney(monto,'',2,'.',',');
})

Vue.filter('mayuscula',(texto)=>{
  return texto.toUpperCase();
})
Vue.filter('recorte',(texto)=>{
  return texto.substr(0, 40)+'...';
})


import moment from 'moment';
Vue.filter('fechaformato', (arg)=> {
  return moment(arg).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
});


Vue.use(Chartkick.use(Chart));

Vue.config.productionTip = false
Vue.use(VueGeoLocation);/*  */

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC-RNQ0dUw3BHo8Sfnjkhh_fe-gDEuMvpM'
  }
})

import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
